import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { Result } from "../Models/Utility/Result"
import {
    getItemList,
    getPageToFetch,
    hasMore
} from "../Models/Client/RemoteData"
import {
    listMetricConstraints,
    loadMoreMetricConstraints
} from "../Actions/API/Metrics"
import { selectIsSysAdmin } from "../Helpers/Functions/Selectors/auth"

export function useMetricConstraints(
    name?: string
): [FetchState<string[]>, (() => void) | undefined] {
    const dispatch = useDispatch()
    const isSysAdmin = useAppState(selectIsSysAdmin)
    const entry = useAppState(state => state.api.metrics.metricConstraints)
    const loadMore = useMemo(
        () =>
            hasMore(entry)
                ? () => dispatch(loadMoreMetricConstraints())
                : undefined,
        [dispatch, entry]
    )

    useEffect(() => {
        const page = getPageToFetch(entry, { name })

        if (page >= 0 && isSysAdmin) {
            dispatch(listMetricConstraints(name, page))
        }
    }, [dispatch, name, entry, isSysAdmin])

    return useMemo(() => {
        if (!isSysAdmin) {
            return [Result.ok([]), loadMore]
        }

        if (
            entry === undefined ||
            entry.list === undefined ||
            entry.list.params.name !== name
        ) {
            return [undefined, loadMore]
        }

        return [Result.ok(getItemList(entry).map(item => item.name)), loadMore]
    }, [entry, isSysAdmin, loadMore, name])
}
